<script>

import { copyTextToClipboard } from '@/utils/sys/copy'
import ArtistSearch from '@/components/artist/ArtistSearch.vue'

export default {
  name: 'SyncView',
  components: { ArtistSearch },
  data() {
    return {
      dialogTitle: '同步《星广汇》红人分成数据',
      dialogFormVisible: false,
      loading: false,
      loadingBatch: false,
      dataList: [],
      pageData: {},
      searchCondition: { ym: null, artist_id: null }
    }
  },
  methods: {
    open() {
      this.dialogFormVisible = true
      this.searchCondition.ym = this.$utils.getLastMonth()
      this.handleQuery()

    },
    handleDialogClose() {

    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },
    dateFormat(dateStr, cFormat) {
      return this.$utils.parseTime(dateStr, cFormat || '{y}-{m}-{d}')
    },
    handleSelectArtist(item) {
      // console.log(item)
      this.searchCondition.artist_id = item.artist_id || ''
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.ym) {
        const ym = this.searchCondition.ym
        const ymArr = ym.split('-')
        condition.year = parseInt(ymArr[0])
        condition.month = parseInt(ymArr[1])
      }

      if (this.searchCondition.artist_id) {
        condition['artist_id'] = this.searchCondition.artist_id
      }

      return condition
    },
    async getList() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000)
      const searchCondition = this.handleSearchCondition()

      const { list } = await this.$api.getKolCommissionSplit(searchCondition)
      this.dataList = list.map((item) => {
        item.is_sync = 'N'
        return item
      })
      this.loading = false
    },
    handleQuery() {
      // this.pageData.current_page = 1
      this.getList()
    },
    handleBatchSync() {
      this.loadingBatch = true
      Promise.all(this.dataList.map((row, index) => {
        if (row.is_sync !== 'Y')
          return this.handleSync(row, index)
      })).then(_value => {
        // console.log(_value)
        this.loadingBatch = false
      }).catch(error => {

        console.error('发生错误:', error)
      }).finally(() => {
        this.loadingBatch = false
      })

    },
    handleRowClick(row, column) {
      const text = row[column.property] || ''
      copyTextToClipboard(text)
      this.$notify.success(`已复制到剪切板:${text}`)
    },
    // eslint-disable-next-line no-unused-vars
    async handleSync(row, index) {
      // alert(index)
      if (row.pd_kol_id) {
        //&& row.is_existed === 'N'
        if (row.is_valid === 'Y') {
          const data = await this.$api.syncArtistDivide({
            artist_id: row.pd_kol_id,
            nickname: row.kol_nickname,
            date_time: row.date_time,
            publicity_pay: row.publicity_pay,
            commerce_pay: 0,
            brokerage_pay: 0,
            other_pay: 0,
            marketing_costs: 0,
            due_total: 0,
            person_tax: 0,
            actual_pay: 0,
            deduct_remark: '',
            settle_method: '',
            need_invoice: '',
            apply_time: '',
            payment_time: ''
          })
          if (data) {
            row.is_sync = 'Y'
            // this.dataList[index]['is_sync'] = 'Y'
          }
        }
      }
    }
  }
}

</script>

<template>
  <div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogFormVisible' width='980px' @close='handleDialogClose'>
      <div>
        <div>
          <el-form inline :model='searchCondition'>
            <el-form-item>
              <el-date-picker
                v-model='searchCondition.ym'
                type='month'
                value-format='yyyy-MM'
                format='yyyy年MM月'
                placeholder='选择月'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <ArtistSearch @handleSelect='handleSelectArtist' />
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' @click='handleQuery' :disabled='loading'
                         :loading='loading'>查询
              </el-button>
            </el-form-item>

            <el-form-item>
              <el-tooltip class='item' effect='dark' content='仅同步有效且未同步的数据' placement='top-start'>
                <el-button type='warning' icon='el-icon-refresh' @click='handleBatchSync' :loading='loadingBatch'
                           :disabled='loadingBatch'>同步
                </el-button>
              </el-tooltip>
            </el-form-item>

          </el-form>
        </div>

        <el-table :data='dataList'
                  @row-dblclick='handleRowClick'
                  :default-sort="{prop: 'is_valid', order: 'descending'}"
                  height='400'>
          <el-table-column type='index' label='序号' width='50' align='center'></el-table-column>
          <el-table-column label='月份' prop='date_time' align='center' width='100' sortable>
            <template slot-scope='{row}'>
              <span>{{ dateFormat(row.date_time, '{y}年{m}月') }}</span>
            </template>
          </el-table-column>
          <el-table-column label='红人昵称' prop='kol_nickname' align='center' sortable></el-table-column>
          <el-table-column label='推广分成' prop='publicity_pay' align='right'>
            <template slot-scope='{row}'>
              {{ row.publicity_pay ? moneyFormat(row.publicity_pay) : '--' }}
            </template>
          </el-table-column>
          <el-table-column label='星象仪ID' prop='pd_kol_id' align='center' show-overflow-tooltip
                           sortable></el-table-column>
          <el-table-column label='星广汇ID' prop='ad_kol_id' align='center' sortable></el-table-column>
          <el-table-column label='是否有效' prop='is_valid' align='center' sortable>
            <template slot-scope='{row}'>
              <el-tag type='success' effect='plain' v-if='row.is_valid==="Y"'>是</el-tag>
              <el-tag type='warning' effect='plain' v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label='已同步' prop='is_existed' align='center' sortable>
            <template slot-scope='{row}'>
              <el-tag type='success' effect='plain' v-if='row.is_existed==="Y"'>是</el-tag>
              <el-tag type='warning' effect='plain' v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label='本轮同步' prop='is_sync' align='center' sortable>
            <template slot-scope='{row}'>
              <el-tag type='success' effect='plain' v-if='row.is_sync==="Y"'>是</el-tag>
              <el-tag type='warning' effect='plain' v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label='操作'>
            <template slot-scope='{row,$index}'>
              <el-link type='primary' @click='handleSync(row,$index)'
                       :disabled='!(row.is_valid==="Y")'
                       v-if='row.pd_kol_id'>
                同步
                <span style='color: #0aab62' class='el-icon-circle-check' v-if='row.is_sync=="Y"'></span>
                <span class='el-icon-refresh' v-else></span>
              </el-link>
              <el-link type='warning' v-else>请先匹配</el-link>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>
